<style lang="scss">
  $searchbox_height: 4.9em; // = 64px (body font size =?)
  $button_size_14px: 3em; // = 42px (body font size = 14px)

  .theme-button{
    // .v-btn.v-size--default font-size: 0.875rem = 14px (= body font size)
    top: $searchbox_height + ($button_size_14px/2);
    z-index: 1;
  }
  .maplogo{
    width: 32px;
    height: 32px;
    min-width: 32px;
  }
</style>
<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      mini-variant-width="56"
    >
      <v-list-item>
          <img src="smartmap_favicon_world.svg" class="maplogo"
               alt="logo of the lausanne web app map for smartphones"/>
        <v-list-item-title class="headline font-weight-bold pl-7">SmartMap</v-list-item-title>
        <v-btn icon @click.stop="mini = !mini" aria-label="fermer menu">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click="navigateTo(item.url)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-btn
      class="theme-button"
      left
      absolute
      height="42"
      width="42"
      min-width="42"
      @click.stop="drawer =! drawer"
      aria-label="selection theme"
    ><v-icon>more_vert</v-icon>
    </v-btn>
<!--
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span>{{appName}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <router-link to="/">Home</router-link> |
      <router-link to="/amenagement">Amenagement</router-link>

      <v-btn
        text
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
      >
        <span class="mr-2">{{appRelease}}</span>
      </v-btn>
    </v-app-bar>
-->
    <v-content class="container--fluid">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import {
  APP,
  DEV,
  getLog,
  VERSION,
  BUILD_DATE,
} from './config';

const MODULE_NAME = APP;
const log = getLog(MODULE_NAME, 4, 2);

export default {
  name: 'App',
  data: () => ({
    title: 'Aménagement',
    appName: APP,
    appRelease: `${VERSION}-build ${BUILD_DATE}`,
    appTitle: `${APP} - ${VERSION}`,
    isInDev: DEV,
    drawer: false,
    items: [
      { title: 'Home', icon: 'home', url: '/' },
      { title: 'Aménagement du territoire', icon: 'filter_hdr', url: '/amenagement' },
      // { title: 'Environnement construit', icon: 'mdi-sprout-outline', url: '/envconstruit' },
      { title: 'Cadastre', icon: 'explore', url: '/cadastre' },
      { title: 'Mobilité', icon: 'directions_bike', url: '/mobilite' },
      // { title: 'Périmètres', icon: 'streetview', url: '/perimetres' },
      { title: 'Plan Ville', icon: 'location_city', url: '/planville' },
      { title: 'Stationnement véhicules', icon: 'time_to_leave', url: '/stationnement' },
    ],
    mini: false,
  }),
  computed: {
  },
  mounted() {
    log.w(`mounted ${this.appTitle} build: ${BUILD_DATE}`);
  },
  methods: {
    navigateTo(destination) {
      log.t(`in navigateTo('${destination}'), currentRoute.path: ${this.$router.currentRoute.path} `);
      if (this.$router.currentRoute.path !== destination) {
        this.$router.push({ path: destination });
      }
    },
  },
};
</script>
